import { render, staticRenderFns } from "./TenderMembers.vue?vue&type=template&id=64a351ff&scoped=true"
import script from "./TenderMembers.vue?vue&type=script&lang=js"
export * from "./TenderMembers.vue?vue&type=script&lang=js"
import style0 from "./TenderMembers.vue?vue&type=style&index=0&id=64a351ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a351ff",
  null
  
)

export default component.exports